import { baseUrl } from "../../../shared/baseUrl";

function Narrations({ reciter, onnarrationClick, goBack }) {
  if (!reciter || !Array.isArray(reciter.riwaayah)) {
    return <p>Loading riwaayah...</p>;
  }

  return (
    <div className="narrations-view">
      <nav className="breadcrumb">
        <span className="crumb clickable" onClick={() => goBack("home")}>
          Home
        </span>

        <span className="separator">›</span>

        <span className="crumb current">{reciter.name}</span>
      </nav>
      <div className="narration-hero">
        <img
          className="narration-hero-image"
          src={`${baseUrl}/storage/${reciter.image}`}
          alt={reciter.name}
        />

        <div className="narration-hero-info">
          <h1 className="narration-title">{reciter.name}</h1>
        </div>
      </div>
      <h2>Riwaayah</h2>
      <hr />
      <div className="narrations-grid">
        {reciter.riwaayah.map((narration) => (
          <button
            key={narration.id}
            className="narration-card"
            onClick={() => onnarrationClick(narration)}
          >
            <img
              src={`${baseUrl}storage/images/quraan-icon.png`}
              alt={narration.name}
            />
            <h4>{narration.name}</h4>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Narrations;
